const CASE_NUMBER_COLLATOR = new Intl.Collator("en-US", {
  numeric: true,
  sensitivity: "base",
});

/**
 * Compare accession numbers in human/numeric order while remaining safe for
 * prefixes and legacy, non-zero-padded numbers.
 */
export function compareCaseNumbers(
  left: string | null | undefined,
  right: string | null | undefined
): number {
  return CASE_NUMBER_COLLATOR.compare(left?.trim() ?? "", right?.trim() ?? "");
}
